import React from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng-fe/errorBoundary';
import styles from './index.css';

class RightContent extends React.PureComponent {
    static propTypes = {
        list: PropTypes.array,
    };

    render() {
        const { list = [] } = this.props;

        if (list.length === 0) return null;

        return (
            <aside className={styles.rightContent} aria-label="相关推荐">
                <h4 className={styles.title}>相关推荐</h4>
                <ul className={styles.list}>
                    {list.map((item) => (
                        <li className={styles.item} key={item.base62Id}>
                            <a href={item.url} target="_blank" title={item.title}>
                                {item.title}
                            </a>
                        </li>
                    ))}
                </ul>
            </aside>
        );
    }
}

export default errorBoundary(RightContent);
